export default __webpack_public_path__ + "static/media/logo_ots_activities.e99f6fe2.png";